<template>
  <div :class="['vtm-stat', tone ? 'vtm-stat--' + tone : '']">
    <div v-if="icon" :class="['vtm-stat__icon', tone ? 'vtm-stat__icon--' + tone : '']">
      <i :class="icon"></i>
    </div>
    <div class="vtm-stat__body">
      <span class="vtm-stat__label">{{ label }}</span>
      <strong class="vtm-stat__value vtm-num">{{ value }}<span v-if="suffix" class="vtm-stat__suffix">{{ suffix }}</span></strong>
      <span v-if="hint" class="vtm-stat__hint">{{ hint }}</span>
    </div>
  </div>
</template>

<script>
  // KPI 统计卡（对应设计方向的 KPI 行）。tone: ''|'ok'|'warn'|'crit'|'info'
  export default {
    name: "StatCard",
    props: {
      label: { type: String, required: true },
      value: { type: [String, Number], default: "-" },
      suffix: { type: String, default: "" },
      hint: { type: String, default: "" },
      icon: { type: String, default: "" },
      tone: { type: String, default: "" }
    }
  };
</script>

<style scoped lang="scss">
  .vtm-stat {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 18px;
    background: var(--vtm-surface);
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
  }

  .vtm-stat--warn { border-color: var(--vtm-warn-soft); }
  .vtm-stat--crit { border-color: var(--vtm-crit-soft); }

  .vtm-stat__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: var(--vtm-r-md);
    font-size: 21px;
    background: var(--vtm-mint-soft);
    color: var(--vtm-mint-ink);

    &--ok { background: var(--vtm-ok-soft); color: var(--vtm-ok); }
    &--warn { background: var(--vtm-warn-soft); color: var(--vtm-warn); }
    &--crit { background: var(--vtm-crit-soft); color: var(--vtm-crit); }
    &--info { background: var(--vtm-info-soft); color: var(--vtm-info); }
  }

  .vtm-stat__body {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .vtm-stat__label {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--vtm-ink-2);
  }

  .vtm-stat__value {
    font-family: var(--vtm-display);
    font-size: 24px;
    font-weight: 650;
    line-height: 1.25;
    color: var(--vtm-heading);
    letter-spacing: -0.02em;
  }

  .vtm-stat--crit .vtm-stat__value { color: var(--vtm-crit); }
  .vtm-stat--warn .vtm-stat__value { color: var(--vtm-warn); }

  .vtm-stat__suffix {
    font-size: 13px;
    color: var(--vtm-ink-3);
    margin-left: 2px;
  }

  .vtm-stat__hint {
    font-size: 11px;
    color: var(--vtm-ink-3);
  }
</style>
